import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material';
import { FormControl, Validators } from '@angular/forms';
import { DEV_MODE_PASSWORD } from '../../_config/dev.constants';

@Component({
	selector: 'kt-dev-role-password-dialog',
	templateUrl: './dev-role-password-dialog.component.html',
	styleUrls: ['./dev-role-password-dialog.component.scss']
})
export class DevRolePasswordDialogComponent {
	passwordControl = new FormControl('', [Validators.required]);
	errorMessage = '';

	constructor(
		public dialogRef: MatDialogRef<DevRolePasswordDialogComponent>
	) {}

	onSubmit(): void {
		if (this.passwordControl.invalid) {
			this.errorMessage = 'Password is required';
			return;
		}

		const password = this.passwordControl.value;
		if (password === DEV_MODE_PASSWORD) {
			this.dialogRef.close(true);
		} else {
			this.errorMessage = 'Incorrect password';
			this.passwordControl.setValue('');
		}
	}

	onCancel(): void {
		this.dialogRef.close(false);
	}
}

